<app-screen-shell [contentClass]="'public-entry-shell email-verification-result-shell'" layout="public-entry" variant="public" [showHeader]="false">
  <section class="email-verification-result-card" [class.is-error]="!success">
    <img class="email-verification-result-logo" src="../assets/images/footballer-zone-logo-transparent.png" alt="Footballer Zone"/>
    <div class="email-verification-result-icon" aria-hidden="true">
      <i [class]="(success ? 'common.check' : 'common.error') | nogoshIcon"></i>
    </div>
    <h1>{{ (success ? 'notifications.emailVerificationResultTitle' : 'notifications.emailVerificationResultErrorTitle') | translate }}</h1>
    <p>{{ (success ? 'notifications.emailVerificationResultDescription' : 'notifications.emailVerificationResultErrorDescription') | translate }}</p>

    @if (success) {
      <button type="button" class="email-verification-result-primary" (click)="openMobileApp()">
        {{ 'notifications.emailVerificationReturnToApp' | translate }}
      </button>
    }
    <button type="button" class="email-verification-result-secondary" (click)="continueInBrowser()">
      {{ 'notifications.emailVerificationContinueInBrowser' | translate }}
    </button>
  </section>
</app-screen-shell>
